import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Bell, ArrowRight } from 'lucide-react';
interface Props {
  onRestart: () => void;
}
const lines = ['ERA wasn’t the destination.', 'It was the start of a new era.'];
export const PostScreen6Closing = ({
  onRestart
}: Props) => {
  const [lineIndex, setLineIndex] = useState(0);
  useEffect(() => {
    if (lineIndex < lines.length - 1) {
      const t = setTimeout(() => setLineIndex(lineIndex + 1), 2500);
      return () => clearTimeout(t);
    }
  }, [lineIndex]);
  return <div className="relative w-full h-full overflow-hidden bg-black flex flex-col" data-id="element-133">
      {/* Background Video */}
      <div className="absolute inset-0" data-id="element-134">
        <video src="https://cdn.magicpatterns.com/uploads/pxuiwUXmXM5xMDMgVxDsQH/congress.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover opacity-70" data-id="element-135" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/80" data-id="element-136" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-green-700/30 rounded-full blur-[100px]" data-id="element-137" />

      <div className="relative z-10 flex-1 flex flex-col justify-end p-8 pb-12" data-id="element-138">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-green-500 font-semibold mb-6" data-id="element-139">
          05 — Stay Connected
        </motion.span>

        <div className="min-h-[120px]" data-id="element-140">
          <AnimatePresence mode="wait" data-id="element-141">
            <motion.h2 key={lineIndex} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} className="text-3xl font-bold text-white leading-tight tracking-tight" data-id="element-142">
              {lineIndex === lines.length - 1 ? <>
                  It was the start of a{' '}
                  <span className="text-green-500" data-id="element-143">new era.</span>
                </> : lines[lineIndex]}
            </motion.h2>
          </AnimatePresence>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: lineIndex === lines.length - 1 ? 1 : 0,
        y: lineIndex === lines.length - 1 ? 0 : 20
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-8 space-y-4" data-id="element-144">
          <button className="w-full bg-green-600 hover:bg-green-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 shadow-[0_10px_40px_rgba(34,197,94,0.4)] active:scale-[0.98] transition-all" data-id="element-145">
            <Bell className="w-5 h-5" data-id="element-146" />
            <span className="text-lg" data-id="element-147">Be part of the new era</span>
          </button>

          <button onClick={onRestart} className="w-full text-slate-400 hover:text-white text-sm py-2 transition-colors" data-id="element-148">
            Restart experience
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: lineIndex === lines.length - 1 ? 1 : 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-10 text-center" data-id="element-149">
          <p className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-150">
            ERA: Inside Access
          </p>
        </motion.div>
      </div>
    </div>;
};